import { setWindowDtm } from '../../utils/DTM';
import { extractUtmSourceFromUrl } from '../../utils/helper';

export const onSuccessPageLoad = () => {
    const dtm = {
        pageName: 'web|home eye checkup program|book an appointment|transaction success',
        channel: 'web|home eye checkup|success',
        hierarchy1: 'web|home eye checkup program|success',
        pageEvent: 'purchase,event21,event22,event32,event40',
        orderStatus: 'success',
        event: 'home-eye-checkup-transaction-success'
    };
    setWindowDtm(dtm);
};

export const triggerDatalayer = (orderId, cartPrice) => {
    const saleSrc = window.location.search ? extractUtmSourceFromUrl(window.location.search) : 'direct';
    const data = {
        event: 'VirtualPageView',
        PageUrl: window.location.href,
        orderId,
        cartPrice,
        saleSrc
    };
    if (window.dataLayer) window.dataLayer.push(data);
};

export const triggerDtmOnload = linkPageName => {
    const dtm = {
        pageName: 'web|home eye checkup program|book an appointment|landing page',
        channel: 'web|home eye checkup',
        hierarchy1: `web|home eye checkup program|${linkPageName}`,
        event: 'home-eye-checkup'
    };
    setWindowDtm(dtm);
};

export const googleConversionAnalyticsHTO = () => {
    // loadFile('https://www.googleadservices.com/pagead/conversion_async.js', 'js', null, 'body');
    /* <![CDATA[ */
    window.goog_snippet_vars = function () {
        const w = window;
        w.google_conversion_id = 998673422;
        w.google_conversion_label = '-Z_JCPKl7QEQjpia3AM';
        w.google_conversion_value = 1.00;
        w.google_conversion_currency = 'INR';
        w.google_remarketing_only = false;
    };
    // DO NOT CHANGE THE CODE BELOW.
    window.goog_report_conversion = function (url) {
        window.goog_snippet_vars();
        window.google_conversion_format = '3';
        const opt = {};
        opt.onload_callback = function () {
            if (typeof (url) !== 'undefined') {
                window.location = url;
            }
        };
        const conv_handler = window.google_trackConversion;
        if (typeof (conv_handler) === 'function') {
            conv_handler(opt);
        }
    };
    /* ]]> */
};
